import { Injectable, inject } from '@angular/core';
import { RynReplayRecorderService } from './ryn-replay-recorder.service';
import {
  RYN_REPLAY_GRID_SNAPSHOTS_CONFIG,
  type IRynReplayGridSnapshotPageConfig,
} from './ryn-replay-grid-snapshots.config';
import {
  findRynReplayGridSnapshotPage,
  leaveRynReplayGridPage,
  trackRynReplayGridPageSnapshot,
  type IRynReplayGridPageTrackInput,
} from './ryn-replay-grid-page-track';

/**
 * App-wide entry point for blocked-grid snapshots (#31398).
 *
 * Pages call `track(pageId, …)` / `leave(pageId)` only. Titles, routes, pause
 * hosts, and fallback columns come from `provideRynReplayGridSnapshots(...)`
 * (one registry per app — not per feature folder).
 */
@Injectable({ providedIn: 'root' })
export class RynReplayGridSnapshotService {
  private readonly recorder = inject(RynReplayRecorderService);
  private readonly config = inject(RYN_REPLAY_GRID_SNAPSHOTS_CONFIG, {
    optional: true,
  });

  /** Look up a registered page (undefined if the app did not provide the registry). */
  page(pageId: string): IRynReplayGridSnapshotPageConfig | undefined {
    return findRynReplayGridSnapshotPage(this.config, pageId);
  }

  track<TRow>(pageId: string, input: IRynReplayGridPageTrackInput<TRow>): void {
    const page = this.page(pageId);
    if (!page) {
      return;
    }
    trackRynReplayGridPageSnapshot(this.recorder, page, input);
  }

  leave(pageId: string): void {
    const page = this.page(pageId);
    if (!page) {
      return;
    }
    leaveRynReplayGridPage(this.recorder, page);
  }
}
